/**
 * @file
 * Attaches the behaviors for the Event component.
 */
!function ($, Drupal) {
  'use strict';

  Drupal.behaviors.events = {
    attach: function attach(context) {
      var currentURL = window.location.href;
      console.log(currentURL);
      // Check if the current URL is one of the specified URLs
      if (
        currentURL.indexOf('/trainings-courses') !== -1 ||
        currentURL.indexOf('/automation') !== -1 ||
        currentURL.indexOf('/CAD') !== -1 ||
        currentURL.indexOf('/CNC') !== -1 ||
        currentURL.indexOf('/Electromechanical') !== -1 ||
        currentURL.indexOf('/Photonics') !== -1 ||
        currentURL.indexOf('/Pre-Engineering-Technology') !== -1 ||
        currentURL.indexOf('/Robotics') !== -1 ||
        currentURL.indexOf('/Welding') !== -1 ||
        currentURL.indexOf('/access-trainings-courses') !== -1 ||
        currentURL.indexOf('/find-tools-job-seekers/all-trainings-courses') !== -1

      ) {
        // Add classes to specific elements on the specified URLs
        $('.event-teaser', context).addClass('mass-makes');
      }

      // Rest of your existing code...
      var $dateValue = $('input[name="field_event_date_value"]', context);
      var $monthValue = $('select[name="field_event_month_value"]', context);
      $monthValue.change(function () {
        $dateValue.val(this.value);
      });
    }
  };
}(jQuery, Drupal);
//# sourceMappingURL=events.js.map
